import React, { useContext, useEffect, useRef, useState } from "react";

import { useTranslation } from 'react-i18next';
import { UserContext } from "../../context/UserContext";
import { Link, useNavigate, useParams } from "react-router-dom";

//import video_animation_mobile from "../../../images/video/ROULETTE_MOB.webm"
//import video_animation_desktop from "../../../images/video/ROULETTE_WEB.webm"

// import video_animation_mobile_mp4 from "../../../images/video/JETON_MOB.mp4"
// import video_animation_desktop_mp4 from "../../../images/video/JETON_WEB.mp4"

/*import video_animation_mobile_mp4 from "../../../images/video/PAQUES_MOB.mp4"
import video_animation_desktop_mp4 from "../../../images/video/PAQUES_WEB.mp4"*/

/*import video_animation_mobile_mp4 from "../../../images/video/ETE_CASINO_MOB.mp4"
import video_animation_desktop_mp4 from "../../../images/video/ETE_CASINO_WEB.mp4"*/

/*import video_animation_mobile_mp4 from "../../../images/video/CB_BW_MOB.mp4"
import video_animation_desktop_mp4 from "../../../images/video/CB_BW_WEB.mp4"
*/

import video_animation_mobile_mp4 from "../../../images/video/REVEAL_MOB.mp4"
import video_animation_desktop_mp4 from "../../../images/video/REVEAL_WEB.mp4"

import video_activite_mobile from "../../../images/video/VIDEO_MOB_1_GAIN.webm"
import video_activite_desktop from "../../../images/video/VIDEO_WEB.webm"

import video_activite_mobile_mp4 from "../../../images/video/VIDEO_MOB_1_GAIN.mp4"
import video_activite_desktop_mp4 from "../../../images/video/VIDEO_WEB.mp4"

const InstantGagnant = () => {

  const { i18n, t } = useTranslation();

  //hook
  const navigate = useNavigate()

  //Context user
  const { user, logout } = useContext(UserContext)

  //url params
  const { code_unique } = useParams();

  //State
  const [dotation, setDotation] = useState("lost")
  const [showDotation, setShowDotation] = useState(false)

  useEffect(() => {

    if(code_unique === "123"){
      setDotation("ACTIVITE")
      return;
    }

    let formData = new FormData();
    formData.append("action", "get_ig");
    formData.append("code_unique", code_unique);
    formData.append("lang", i18n.language);

    fetch(process.env.REACT_APP_API_URL + '/index.php',
      {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': `Bearer ${user.jwt}`
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.success) {
          window.mixpanelhandler.track("Rewards page_Loaded", { "Result count": 1 })
          setDotation(json.data.dotation)
        }
        else
          navigate("/mes-cartes")
      });
  }, []);

  return (
    <div className={"strate footer"} id={"InstantGagnantStrate1"}>
      {!showDotation &&
        <>
          <video id="roulette" className={"d-none d-lg-block"} muted={true} autoPlay={true} onEnded={() => setShowDotation(true)} playsInline={true}>
            {/*<source src={video_animation_desktop} />*/}
            <source src={video_animation_desktop_mp4} />
          </video>
          <video id="roulette" className={"d-lg-none"} muted={true} autoPlay={true} onEnded={() => setShowDotation(true)} playsInline={true}>
            {/*<source src={video_animation_mobile} />*/}
            <source src={video_animation_mobile_mp4} />
          </video>
        </>
      }
      {showDotation &&
        <div id={"dotation_wrapper"} className={dotation}>

          {dotation !== "lost" &&
            <>
              <h1 dangerouslySetInnerHTML={{ __html: t("instantgagnant_felicitation") }} />
              <div dangerouslySetInnerHTML={{ __html: t("instantgagnant_vous_avez_gagne") }} />
              {dotation === "ACTIVITE" &&
                <>
                  <video id="video_activite" className={"d-none d-lg-block"} controls={true} playsInline={true} autoPlay={true} loop={true} muted={true}>
                    <source src={video_activite_desktop} />
                    <source src={video_activite_desktop_mp4} />
                  </video>
                  <video id="video_activite" className={"d-lg-none"} controls={true} playsInline={true} autoPlay={true} loop={true} muted={true}>
                    <source src={video_activite_mobile} />
                    <source src={video_activite_mobile_mp4} />
                  </video>
                  <div className={"dotation_title"} dangerouslySetInnerHTML={{ __html: t("instantgagnant_1_activite") }} />
                </>
              }
              {dotation === "CARTE" &&
                <>
                  <div id={"carte"} />
                  <div className={"dotation_title"} dangerouslySetInnerHTML={{ __html: t("instantgagnant_1_carte_cadeau") }} />
                </>
              }
              <p className={"dotation_mention"} dangerouslySetInnerHTML={{ __html: t("instantgagnant_rendez_vous_email") }} />
            </>
          }

          {dotation === "lost" && <h1 dangerouslySetInnerHTML={{ __html: t("instantgagnant_retentez_votre_chance") }} />}

          <div className={"dotation_block"}>
            <p dangerouslySetInnerHTML={{ __html: t("instantgagnant_collecter_nouvelle_carte") }} />
            <Link to={"/prochainement"} className={"cta gold"}>{t("instantgagnant_en_savoir_plus")}</Link>
          </div>

        </div>
      }

    </div>
  )
}

export default InstantGagnant
